import { z } from "zod";

export const UserSchema = z.object({
    id: z.string().transform(Number).nullish(),
    username: z.string().nullish(),    
    name: z.string().nullish(),
    superadmin: z.string().nullish(),
    roleid: z.string().transform(Number).nullish(),
    lastlogin: z.string().nullish(),
    lastloginip: z.string().nullish(),        
    token: z.string().nullish(),
    dateadded: z.string().nullish(),
}).nullish();

export type User = z.infer<typeof UserSchema>;